
export const JS_RELEASE_VERSION = '1.7.1';

/**
 * The dusk phone number to use for IT support and enquiries.
 * @type {string}
 */
export const IT_SUPPORT_PHONE = null;

/**
 * The dusk email address number to use for IT support and enquiries.
 * @type {string}
 */
export const IT_SUPPORT_EMAIL = 'itsupport@dusk.com.au';

/**
 * The dusk email address number to use for Loyalty support and enquiries.
 * @type {string}
 */
export const LOYALTY_SUPPORT_EMAIL = 'loyaltysupport@dusk.com.au';


// TODO: needs to come from db...
export const COUNTRY_STATE_OPTIONS = [
    {
        key: 'act',
        value: 'ACT'
    },
    {
        key: 'nsw',
        value: 'NSW'
    },
    {
        key: 'nt',
        value: 'NT'
    },
    {
        key: 'qld',
        value: 'QLD'
    },
    {
        key: 'sa',
        value: 'SA'
    },
    {
        key: 'tas',
        value: 'TAS'
    },
    {
        key: 'vic',
        value: 'VIC'
    },
    {
        key: 'wa',
        value: 'WA'
    },
];

export const COUNTRY_STATE_OPTIONS_AU = [
    {
        key: 'act',
        value: 'ACT'
    },
    {
        key: 'nsw',
        value: 'NSW'
    },
    {
        key: 'nt',
        value: 'NT'
    },
    {
        key: 'qld',
        value: 'QLD'
    },
    {
        key: 'sa',
        value: 'SA'
    },
    {
        key: 'tas',
        value: 'TAS'
    },
    {
        key: 'vic',
        value: 'VIC'
    },
    {
        key: 'wa',
        value: 'WA'
    },

];

export const COUNTRY_STATE_OPTIONS_NZ = [
    {
        key: 'nz',
        value: 'NZ'
    },
];

export const COUNTRY_OPTIONS = [
    {
        key: 'globals_nz',
        value: 'New Zealand'
    },{
        key: 'globals_au',
        value: 'Australia'
    }
];

// TODO: needs to come from db...
export const STORE_LOCATION_OPTIONS_AU = [
    {key: '153', value: 'Albury, NSW'},
    {key: '115', value: 'Armadale, WA'},
    {key: '151', value: 'Baldivis, WA'},
    {key: '33', value: 'Belconnen, ACT'},
    {key: '67', value: 'Belmont, WA'},
    {key: '138', value: 'Belrose, NSW'},
    {key: '76', value: 'Bendigo, VIC'},
    {key: '64', value: 'Blacktown, NSW'},
    {key: '152', value: 'Bondi, NSW'},
    {key: '3', value: 'Booragoon, WA'},
    {key: '61', value: 'Broadmeadows, VIC'},
    {key: '132', value: 'Browns Plains, QLD'},
    {key: '92', value: 'Bunbury Forum, WA'},
    {key: '145', value: 'Bundaberg, QLD'},
    {key: '2', value: 'Burwood, NSW'},
    {key: '41', value: 'Cairns, QLD'},
    {key: '118', value: 'Capalaba, QLD'},
    {key: '107', value: 'Carindale, QLD'},
    {key: '129', value: 'Carousel, WA'},
    {key: '603', value: 'Castle Hill, NSW'},
    {key: '87', value: 'Castletown, QLD'},
    {key: '42', value: 'Casuarina, NT'},
    {key: '154', value: 'Chadstone, NSW'},
    {key: '14', value: 'Charlestown, NSW'},
    {key: '27', value: 'Chermside, QLD'},
    {key: '48', value: 'Chirnside Park, VIC'},
    {key: '124', value: 'Cockburn Gateway, WA'},
    {key: '113', value: 'Coffs Harbour, NSW'},
    {key: '57', value: 'Colonnades, SA'},
    {key: '146', value: 'Coomera, QLD'},
    {key: '122', value: 'Craigieburn, VIC'},
    {key: '150', value: 'Cranbourne, VIC'},
    {key: '1', value: 'Customer Support'},
    {key: '50', value: 'Doncaster, VIC'},
    {key: '25', value: 'Eastland, VIC'},
    {key: '43', value: 'Elizabeth, SA'},
    {key: '95', value: 'Epping Plaza, VIC'},
    {key: '26', value: 'Erina, NSW'},
    {key: '36', value: 'Fountain Gate, VIC'},
    {key: '54', value: 'Frankston, VIC'},
    {key: '70', value: 'Geelong, VIC'},
    {key: '37', value: 'Greensborough, VIC'},
    {key: '53', value: 'Helensvale, QLD'},
    {key: '125', value: 'Hervey Bay, QLD'},
    {key: '9', value: 'Highpoint, VIC'},
    {key: '31', value: 'Hornsby, NSW'},
    {key: '123', value: 'Indooroopilly, QLD'},
    {key: '91', value: 'Innaloo, WA'},
    {key: '144', value: 'Ipswich, QLD'},
    {key: '77', value: 'Joondalup, WA'},
    {key: '134', value: 'Kawana, QLD'},
    {key: '20', value: 'Knox, VIC'},
    {key: '100', value: 'Kotara, NSW'},
    {key: '117', value: 'Launceston, TAS'},
    {key: '59', value: 'Liverpool, NSW'},
    {key: '18', value: 'Loganholme, QLD'},
    {key: '56', value: 'Macarthur, NSW'},
    {key: '98', value: 'Mackay, QLD'},
    {key: '84', value: 'Macquarie Centre, NSW'},
    {key: '137', value: 'Mandurah, WA'},
    {key: '23', value: 'Marion, SA'},
    {key: '128', value: 'Midland Gate, WA'},
    {key: '4', value: 'Miranda, NSW'},
    {key: '66', value: 'Morayfield, QLD'},
    {key: '130', value: 'Morley, WA'},
    {key: '127', value: 'Mt Gravatt, QLD'},
    {key: '120', value: 'Mt Ommaney, QLD'},
    {key: '135', value: 'Narellan, NSW'},
    {key: '63', value: 'North Lakes, QLD'},
    {key: '108', value: 'Northland, VIC'},
    {key: '143', value: 'Nowra, NSW'},
    {key: '106', value: 'Ocean Keys, WA'},
    {key: '86', value: 'Pacific Fair, Qld'},
    {key: '102', value: 'Pagewood, NSW'},
    {key: '12', value: 'Penrith, NSW'},
    {key: '69', value: 'Plenty Valley, VIC'},
    {key: '111', value: 'Port Central, NSW'},
    {key: '45', value: 'Rhodes, NSW'},
    {key: '78', value: 'Robina Town Centre, QLD'},
    {key: '79', value: 'Rockhampton, QLD'},
    {key: '74', value: 'Rockingham, WA'},
    {key: '90', value: 'Rosny Park, TAS'},
    {key: '62', value: 'Rouse Hill, NSW'},
    {key: '112', value: 'Shell Harbour, NSW'},
    {key: '28', value: 'Southland, VIC'},
    {key: '140', value: 'Springfield Central, QLD'},
    {key: '133', value: 'Sunshine Plaza, QLD'},
    {key: '21', value: 'Tea Tree Plaza, SA'},
    {key: '147', value: 'The Glen, VIC'},
    {key: '105', value: 'Toowoomba, QLD'},
    {key: '119', value: 'Townsville, QLD'},
    {key: '149', value: 'Traralgon, VIC'},
    {key: '13', value: 'Tuggerah, NSW'},
    {key: '94', value: 'Tuggeranong, ACT'},
    {key: '88', value: 'Wagga, ACT'},
    {key: '139', value: 'Warringah Mall, NSW'},
    {key: '60', value: 'Watergardens, VIC'},
    {key: '141', value: 'Waurn Ponds, VIC'},
    {key: '142', value: 'Wendouree, VIC'},
    {key: '104', value: 'Werribee, VIC'},
    {key: '99', value: 'Westlakes, SA'},
    {key: '97', value: 'Wetherill Park, NSW'},
    {key: '131', value: 'Whitford City, WA'},
    {key: '7', value: 'Woden, ACT'},
    {key: '126', value: 'Wollongong, NSW'},
    {key: '121', value: 'Woodgrove, VIC'},

];

export const STORE_LOCATION_OPTIONS_NZ = [
    {
        key: '20002',
        value: 'Manakau, Auckland'
    },
    {
        key: '20003',
        value: 'Queensgate, Wellington'
    },
    {
        key: '20004',
        value: 'North West, Auckland'
    },
    {
        key: '20001',
        value: 'Customer Support'
    },

]

export const INVALID_DOMAINS = {
    '*.con':        'INVALID',
    'hotmai.com': 	'hotmail.com',
    'hotmial.com': 	'hotmail.com',
    'gmaill.com': 	'gmail.com',
    'yahoo.com.uk':	'yahoo.com',
    'hotmail.com.uk': 'hotmail.com',
    'gail.com': 	'gmail.com',
    'gmal.com': 	'gmail.com',
    'hotmil.com': 	'hotmail.com',
    'hotmail.cm': 	'hotmail.com',
    'noemail.com': 	'INVALID',
    'hormail.com': 	'hotmail.com',
    'hotmail.co': 	'hotmail.com',
    'gmail.co': 	'gmail.com',
    'gmail.con': 	'gmail.com',
    'hotmail.coom': 'hotmail.com',
    'gmail.om': 	'gmail.com',
    'bigpod.com': 	'bigpond.com',
    'jhotmail.com': 'hotmail.com',
    'gmil.com': 	'gmail.com',
    'gmailc.om': 	'gmail.com',
    'gnail.com': 	'gmail.com',
    'gmaol.com': 	'gmail.com',
    'tahoo.com': 	'yahoo.com',
    'hotmail.ocm': 	'hotmail.com',
    'gmail.cim': 	'gmail.com',
    'hotmail.om': 	'hotmail.com',
    'gmail.c': 	    'gmail.com',
    'gmail.cm': 	'gmail.com',
    'gmaul.com': 	'gmail.com',
    'yahoo.cpm': 	'yahoo.com',
    'hotnail.com': 	'hotmail.com',
    'hotmail.con': 	'hotmail.com',
    'yahoo.con': 	'yahoo.com',
    'gogglemail.com': 	'gmail.com',
    'gmai.com':     'gmail.com',
};
